import { useMutation, useQuery } from "react-query"
import { useMainContext } from "../../contexts/main"
import {getPing, normalFetch} from "../fetch-api/get"
import { deleteApi } from "../fetch-api/delete"
import { HOME } from "../../constants/urls"
import {useQueryContext} from "../../contexts/query";


/**
 * Profile - Get api
 * @returns {UseQuery}
 */
const useProfileQuery = () => {

    const { profile: { token, setToken } } = useMainContext()

    return useQuery(
        'fetch-profile', () => normalFetch(token, "profile"),
        {
            enabled: !!token,
            select: (res) => (res.data.data),
            refetchOnWindowFocus: false,
            staleTime: 30 * 60 * 1000,
            retry: 0,
            onError: (res) => {
                if (res.response.status === 401) {
                    setToken('')
                    window.location.href = HOME + "user/register-signin"
                }
            }
        }
    )
}

/**
 * Logout - Post api
 * @returns {UseMutation}
 */
const useLogout = (onSuccess) => {

    const { profile: { token } } = useMainContext()

    return useMutation(
        'logout', () => deleteApi(token, "auth/token"),
        {
            onSuccess
        }
    )
}


const useCheckToken = () => {

    const { profile: { token, setToken } } = useMainContext()
    const { setToast } = useQueryContext()

    return useQuery(
        'check-token', () => normalFetch(token, 'auth/sessions/self/active'),
        {
            refetchOnWindowFocus: false,
            retry: 0,
            enabled: !!token,
            onError: () => {
                setToken('')
                setToast({
                    message: "logout-success",
                    isError: false, show: true
                })
                setTimeout(() => {
                    setToken('')
                    window.location.href = HOME + "user/register-signin"
                }, 1000)
            }
        }
    )

}

const usePing = () => {

    return useQuery(
        'ping', () => getPing(),
        {
            retry: 0
        }
    )
}


export {
    useProfileQuery,
    useLogout,
    useCheckToken,
    usePing
}

